// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p[data-v-19f508dc]{font-size:.8rem}", ""]);
// Exports
module.exports = exports;
